import { store, getContext, getElement } from '@wordpress/interactivity';

// Exploratory function to use a single list of items, half of 
// which are duplicates.
function organizeContentDuplicateListItems(rootElement, isRandomized, animationVelocity, contentList) {
  let originalListItems = contentList.querySelectorAll('li');
  if (isRandomized) {
    const randomizedListItems = Array.from(originalListItems).sort(() => Math.random() - 0.5);
    contentList.innerHTML = ''; // Clear the list
    randomizedListItems.forEach(item => {
      contentList.appendChild(item);
    });
    originalListItems = randomizedListItems;
  }

  originalListItems.forEach((item => {
    const clonedItem = item.cloneNode(true);
    // Add a hidden ARIA attribute.
    clonedItem.setAttribute('aria-hidden', 'true');
    contentList.appendChild(clonedItem);
  }));
  
  const animationDistance = contentList.scrollWidth;
  const animationDurationInSeconds = (animationDistance / animationVelocity);

  const animationDuration = `${animationDurationInSeconds}s`;
  contentList.style.animationDuration = animationDuration;
}

// Actual implementation, which duplicates the entire list and marks the
// duplicate as hidden.
function organizeContentDuplicateLists(rootElement, isRandomized, animationVelocity, contentList) {
  // Must randomize the list items before duplicating them.
  if (isRandomized) {
    const listItems = contentList.querySelectorAll('li');
    const shuffledItems = Array.from(listItems).sort(() => Math.random() - 0.5);
    contentList.innerHTML = '';
    shuffledItems.forEach(item => contentList.appendChild(item));
  }
  
  // // Duplicate the content list and append it to the root element
  const clonedList = contentList.cloneNode(true);
  clonedList.classList.add('cloned');
  // Add a hidden ARIA attribute.
  clonedList.setAttribute('aria-hidden', 'true');
  rootElement.appendChild(clonedList);


  const animationDistance = contentList.scrollWidth;
  const animationDurationInSeconds = (animationDistance / animationVelocity);

  const animationDuration = `${animationDurationInSeconds}s`;
  contentList.style.animationDuration = animationDuration;
  clonedList.style.animationDuration = animationDuration;
}

const { state, actions } = store("amplifyStorytellingMarquee", {
  state: {
  },

  actions: {
  },

  callbacks: {
    init: () => {
      const context = getContext();
      console.debug(`[amplifyStorytellingMarquee.init] context:`, context)

      const animationVelocity = context.animationVelocity || 25; // pixels per second
      const isRandomized = context.randomize === true;
      const animationDirection = context.animationDirection || 'right-to-left';

      const { ref } = getElement();

      // Get direct descendent UL of the root element
      const contentList = ref.querySelector('ul');

      // Ensure we have a valid content list
      if (!contentList) {
        console.error(`[amplifyStorytellingMarquee.init] No content list found.`);
        return;
      }

      organizeContentDuplicateLists(ref, isRandomized, animationVelocity, contentList);

      // Flag that this component has been initialized.
      context.isInitialized = true;

      // Begin animation.
      const animationDelay = context.animationDelay || 0; // in milliseconds
      setTimeout(() => {
        console.debug(`[amplifyStorytellingMarquee.init] Starting animation after ${animationDelay}ms`);
        const animationDirectionClass = `amplify-storytelling-marquee--scroll-${animationDirection}`;
        ref.classList.add(animationDirectionClass);
      }, animationDelay);
    },
  },
});
